import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { LuHandHeart } from "react-icons/lu";
import "./ServicesCards.css";

export default function ServicesCards(props) {
  return (
    <Container className="services-section">
      <Row>
        <Col className="services-first-col">
          <h2 style={{ color: props.titleColor, fontSize: props.titleSize }}>
            <LuHandHeart
              style={{ color: props.iconColor }}
              className="services-icon"
            />
            NOSSOS SERVIÇOS
          </h2>
        </Col>
      </Row>
      <Row>
        {props.cards.map((card) => (
          <Col key={card.id} className="services-second-col">
            <div style={{ height: props.cardSize }} className="services-card">
              <img src={card.image} alt="serviço" className="services-img" />
              <div
                style={{
                  backgroundColor: props.white,
                  top: props.textTop,
                  minHeight: props.textMinHeight,
                }}
                className="services-card-text"
              >
                {card.title}
                {card.subTitle}
                <div>
                  <div
                    style={{ fontSize: props.textSize }}
                    className="services-card-text-item"
                  >
                    {card.icon1}
                    {card.item1}
                  </div>
                  <div
                    style={{ fontSize: props.textSize }}
                    className="services-card-text-item"
                  >
                    {card.icon2}
                    {card.item2}
                  </div>
                  <div
                    style={{ fontSize: props.textSize }}
                    className="services-card-text-item"
                  >
                    {card.icon3}
                    {card.item3}
                  </div>
                  <div
                    style={{ fontSize: props.textSize }}
                    className="services-card-text-item"
                  >
                    {card.icon4}
                    {card.item4}
                  </div>
                  {!card.item5 ? (
                    ""
                  ) : (
                    <div
                      style={{ fontSize: props.textSize }}
                      className="services-card-text-item"
                    >
                      {card.icon5}
                      {card.item5}
                    </div>
                  )}
                  {!card.item6 ? (
                    ""
                  ) : (
                    <div
                      style={{ fontSize: props.textSize }}
                      className="services-card-text-item"
                    >
                      {card.icon6}
                      {card.item6}
                    </div>
                  )}
                  {!card.item7 ? (
                    ""
                  ) : (
                    <div
                      style={{ fontSize: props.textSize }}
                      className="services-card-text-item"
                    >
                      {card.icon7}
                      {card.item7}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}
